<div id="head_wrap">
    <div id="head_left" class="fontSize14" [ngClass]="{'head_selected':personalReportListSelected,'head_not_selected':!personalReportListSelected}" (click)="selectReportList(true)">
       个人报告
    </div>

    <div id="head_right" class="fontSize14" [ngClass]="{'head_selected':!personalReportListSelected,'head_not_selected':personalReportListSelected}" (click)="selectReportList(false)">
      团体报告
    </div>
</div>


<div id="personalWrap" *ngIf="personalReportListSelected">
   <ul *ngIf="users">
     <li *ngFor="let user of users;" (click)="showDetailReport(user.user_id)">
       <img src="{{user.headimgurl}}" alt="" class="listPic">
        <div class="listName fontSize16">
            <span>{{user.name}}</span>
        </div>
       <div class="listDepartment fontSize16">
            <span>{{user.department}}</span>
       </div>
       <div class="listJob fontSize16">
           <span>{{user.title}}</span>
       </div>
     </li>
   </ul>
</div>

<div id="teamWrap" *ngIf="!personalReportListSelected  && companyReport">
  <div class="fontSize26 title">
      团体学习情况表
  </div>

  <div id="table1Wrap" class="fontSize16">
    <div id="table1Top">
        <div id="table1Top1">序号</div>
        <div id="table1Top2">姓名</div>
        <div id="table1Top3">学习进程</div>
        <div id="table1Top4">测试级别</div>
    </div>
    <table id="table1" class="fontSize16" *ngIf="companyReport && companyReport.users">
      <tr>
        <th>序号</th>
        <th>姓名</th>
        <th>学习进程</th>
        <th>测试级别</th>
      </tr>
      <tr *ngFor="let user of companyReport.users;index as i;">
        <td>{{i+1}}</td>
        <td>{{user.name}}</td>
        <td>
            <span class="graduated" *ngIf="user.status=='已毕业'">{{user.status}}</span>
            <span class="failedColor" *ngIf="user.status=='未通过'">{{user.status}}</span>
            <span class="notCompleted" *ngIf="user.status=='未完成'">{{user.status}}</span>
        </td>
        <td>{{user.level}}</td>
      </tr>
    </table>
  </div>

  <div class="fontSize26 title" *ngIf="companyReport && companyReport.abilities && companyReport.abilities.length > 0">
    团体平均能力发展图
  </div>

  <div id="chartWrap" *ngIf="companyReport && companyReport.abilities && companyReport.abilities.length > 0">
    <div id="chartHead">
      <div class="fontSize16 chartHeadItem" *ngFor="let ability of companyReport.abilities; let i = index;" [ngClass]="{'chartHeadSelected':selectedAbilityIndex===i}" (click)="selectAbility(i)">{{ability.name}}</div>
    </div>

    <div *ngFor="let ability of companyReport.abilities; let i = index;">
      <div class="abilityWrap" [ngClass]="{'visibilityHidden':selectedAbilityIndex!=i || (ability.preSurveyAvg == 0&&ability.postSurveyAvg == 0)}">
      <div class="fontSize21 subtitle">
          <span *ngIf="ability.postSurveyAvg == 0">平均能力诊断等级图</span>
          <span *ngIf="ability.postSurveyAvg != 0">平均能力诊断考核对比图</span>
      </div>
      <div id="after_wrap_1" *ngIf="ability.preSurveyAvg != 0">
        <div class="float_left fontSize16">
          诊断
        </div>
        <div class="bar_bottom barBottomPre" id="after_wrap_1_left">
          <div class="bar_top barTopPre" [ngClass]="{'level0':ability.preSurveyAvg == 0,'level1':ability.preSurveyAvg == 1,'level2':ability.preSurveyAvg == 2,'level3':ability.preSurveyAvg == 3,'level4':ability.preSurveyAvg == 4,'level5':ability.preSurveyAvg == 5,'level6':ability.preSurveyAvg == 6,'level7':ability.preSurveyAvg == 7}"></div>
        </div>
        <div class="float_right fontSize16">
          <span class="fontSize16 wrap_text_1" *ngIf="ability">L{{ability.preSurveyAvg}}</span><span class="fontSize14">&nbsp;/&nbsp;L7</span>
        </div>
      </div>

      <div id="after_wrap_2" *ngIf="ability.postSurveyAvg != 0">
        <div class="float_left fontSize16">
          考核
        </div>
        <div class="bar_bottom barBottomPost" id="after_wrap_2_left">
          <div class="bar_top barTopPost" id="after_bar_top" [ngClass]="{'level0':ability.postSurveyAvg == 0,'level1':ability.postSurveyAvg == 1,'level2':ability.postSurveyAvg == 2,'level3':ability.postSurveyAvg == 3,'level4':ability.postSurveyAvg == 4,'level5':ability.postSurveyAvg == 5,'level6':ability.postSurveyAvg == 6,'level7':ability.postSurveyAvg == 7}"></div>
        </div>
        <div class="float_right fontSize16">
          <span class="fontSize16 wrap_text_1" *ngIf="ability">L{{ability.postSurveyAvg}}</span><span class="fontSize14">&nbsp;/&nbsp;L7</span>
        </div>
      </div>

      <div class="fontSize21 subtitle" id="coachSubtitle2" style="visibility: hidden">团队能力解读及发展建议</div>
      <div class="fontSize16" id="coachText" style="visibility: hidden">
          团队领导者乐意倾听，善于了解下属需求并提供及时的指导和反馈，帮助下属提高特定知识或技巧，以顺利完成工作<br/>
          这样的领导能力可以帮助组织：<br/>
          *专注目标达成，有效拆解任务目标，通过任务下放、技能辅导等方式达成。
      </div>
    </div>
    </div>

    <div id="notStart" *ngIf="!coachSelected||coachSelected&&companyReport.preSurveyAvg == 0&&companyReport.postSurveyAvg == 0">
        <div id="notStartPic"></div>
        <div id="notStartText" class="fontSize16">
            很遗憾，<br/>
            由于你没有开始进行测验，<br/>
            我们无法为你生成报告。<br/>
        </div>
    </div>
  </div>

  <!--
  <div class="fontSize26 title">
    团体关键行动分析表
  </div>

  <table id="table2" class="fontSize16" *ngIf="companyReport && companyReport.userKas">
    <tr>
      <th>姓名</th>
      <th>优秀表现</th>
      <th>表现欠佳</th>
    </tr>
    <tr *ngFor="let userKa of companyReport.userKas;">
      <td>{{userKa.name}}</td>
      <td [innerHtml]="userKa.goodKaNames"></td>
      <td [innerHtml]="userKa.badKaNames"></td>
    </tr>
  </table>
  -->
</div>



// WEBPACK FOOTER //
// ./src/app/hr-report-overview/hr-report-overview.component.html